import { Component, inject, OnInit, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { KpiComponent } from "../../../../shared/components/kpi/kpi.component";
import { AssetHierarchyComponent } from "../../../../shared/widgets/asset-hierarchy/asset-hierarchy.component";

import { TranslateModule } from "@ngx-translate/core";

import { GateFaultTableComponent } from "../../../../shared/widgets/gate-fault-table/gate-fault-table.component";
import { CustomerMapComponent } from "../../../../shared/widgets/customer-map/customer-map.component";
import { RepairsComponent } from "../../../repairs/repairs.component";
import { OpenNoticeCardComponent } from "../../../../shared/widgets/open-notice-card/open-notice-card.component";
import { TenantHomeService } from "./facade/tenant-home.service";

import { SimplebarAngularModule } from "simplebar-angular";
import { AuthService } from "../../../../services/api/auth/auth.service";
import { OpenNoticeConfig } from "../../../../models/ui/openNoticeConfig";

@Component({
  standalone: true,
  selector: "app-tenant",
  imports: [
    KpiComponent,
    AssetHierarchyComponent,
    TranslateModule,
    GateFaultTableComponent,
    CustomerMapComponent,
    RepairsComponent,
    OpenNoticeCardComponent,
    SimplebarAngularModule,
  ],
  templateUrl: "./tenant.component.html",
  styleUrl: "./tenant.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [TenantHomeService],
})
export class TenantComponent implements OnInit, OnDestroy {
  public openFaultsConfig!: OpenNoticeConfig;
  public openServicesConfig!: OpenNoticeConfig;

  public selectedAssetId!: string;

  private authService = inject(AuthService);
  public tenantPageFacade = inject(TenantHomeService);

  public ngOnInit() {
    this.authService.getAuthenticatedUser().subscribe({
      next: (res) => {
        const tenantId = res?.tenant?.id;
        if (tenantId) {
          this.tenantPageFacade.loadInitialState(tenantId);
        }
      },
    });
    this.openFaultsConfig = {
      icon: { name: "fault", color: "warning" },
      labels: ["tenant_home_page.open_faults.warning", "tenant_home_page.open_faults.critical"],
    };
    this.openServicesConfig = {
      icon: { name: "repair", color: "primary" },
      labels: ["tenant_home_page.open_services.service", "tenant_home_page.open_services.repair"],
    };
  }

  public ngOnDestroy() {
    this.tenantPageFacade.destroy();
  }
}
